<template>
  <MRow :gutter="0">
    <MCol>
      <h5 class="text-primary"> {{ $t('import_csv.map_fields') }} </h5>
      <div class="text-neutral-light">
        {{ $t('import_csv.mapping_instruction') }}
      </div>
      <MDivider />
      <div
        v-for="(columns, key) in resourceColumnsGroupBy"
        :key="key"
        class="my-2 px-2"
      >
        <h5>
          {{
            moduleName === $constants.SINGLE_COLUMN
              ? $tc('field')
              : key === $constants.CMDB
              ? $tc('ci')
              : $tc(key)
          }}
          {{ $tc('details') }}
        </h5>
        <MDivider />
        <ColumnMappingPicker
          v-for="column in columns"
          :key="column.columnKey"
          :value="value[column.columnKey]"
          :column-options="columnOptions"
          :column-name="column.columnName"
          :required="column.required"
          @change="handleChangeValue({ [column.columnKey]: $event })"
        />
      </div>
    </MCol>
  </MRow>
</template>

<script>
import GroupBy from 'lodash/groupBy'
import ColumnMappingPicker from './column-mapping-picker'

export default {
  name: 'Step2',
  components: { ColumnMappingPicker },
  model: { event: 'change' },
  props: {
    value: { type: Object, required: true },
    fileColumns: { type: Array, required: true },
    resourceColumns: { type: Array, required: true },
    moduleName: { type: String, required: true },
  },
  computed: {
    columnOptions() {
      return this.fileColumns.map((c) => ({ text: c, key: c }))
    },
    resourceColumnsGroupBy() {
      return GroupBy(this.resourceColumns, 'groupName')
    },
  },
  methods: {
    handleChangeValue(change) {
      this.$emit('change', {
        ...this.value,
        ...change,
      })
    },
  },
}
</script>
